import { createFormItem } from "@/component-create/utils/create-form-item"
import { FormDialog } from "@/component-create/FormDialog"
import { FORM_ITEM } from "@/components/form/enums"

import RecipientSelect from '@/views/components/RecipientSelect.vue'

import XTinyMce from '@/components/x-tiny-mce/XTinyMce.vue'
import { MAIL_BASE_URL } from "@/api/system/mail"

/**
 * 绘制新增表单
 */
 export function renderMailAdd(el: Element) {
  const addForm = new FormDialog(
    el, 
    { 
      items: items, 
      elFormProps: { rules: rules }, 
      saveUrl: MAIL_BASE_URL 
    },
    '新增',
    undefined,
    '60%'
  )

  return addForm
}

const items = [
  [
    createFormItem('名称', 'mailName', FORM_ITEM.INPUT, { clearable: true, maxlength: '64' }),
    createFormItem('代码', 'mailCode', FORM_ITEM.INPUT, { clearable: true, maxlength: '64' }),
    createFormItem('类型', 'mailType', FORM_ITEM.SELECT, { loader: 'MAIL_TYPE' })
  ],
  [
    createFormItem('主题', 'mailSubject', FORM_ITEM.INPUT, { clearable: true, maxlength: '256' }),
  ],
  [
    createFormItem('正文', 'mailContent', XTinyMce),
  ],
  [
    createFormItem('收件', 'to', RecipientSelect as VueComponent, { multiple: true }),
    createFormItem('抄送', 'cc', RecipientSelect as VueComponent, { multiple: true }),
    createFormItem('密送', 'bcc', RecipientSelect as VueComponent, { multiple: true }),
  ],
  [
    createFormItem('备注', 'remark', FORM_ITEM.INPUT, { type: 'textarea', rows: 3, maxlength: '200', showWordLimit: true }),
  ]
]

const rules = {
  mailName: [{ required: true, message: '请输入邮件名称', trigger: 'blur' }],
  mailCode: [{ required: true, message: '请输入邮件代码', trigger: 'blur' }],
  mailType: [{ required: true, message: '请输入邮件类型', trigger: 'blur' }],
  mailSubject: [{ required: true, message: '请输入邮件主题', trigger: 'blur' }],
  mailContent: [{ required: true, message: '请输入邮件正文', trigger: 'blur' }],
  to: [{ required: true, message: '请选择收件人', trigger: 'blur' }]
}